import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import classnames from 'classnames';

import { logout } from '../../store/slices/user.slice';
import { warningToast } from '../../store/slices/toaster.slice';
import { logout as logoutRequest } from '../../misc/requests';
import { AppHeader, BaseButtonLink, BaseButtonOutline, LanguageSwitcher } from '..';

import './AppHeaderDefault.scss';

export const AppHeaderDefault = (props) => {
  const dispatch = useDispatch();

  const loggedIn = useSelector((state) => state.user.loggedIn);
  const isAdmin = useSelector((state) => state.user.details.is_admin);

  const location = useLocation();

  const { children, isAdvisor, adminHeader, controls, hideControls } = props;

  const { t: common } = useTranslation('common');
  const navigate = useNavigate();

  const [logoutLoading, setLogoutLoading] = useState(false);
  const navigateToRoute = (name) => {
    navigate(name);
  };

  const handleLogout = async () => {
    setLogoutLoading(true);

    try {
      await logoutRequest();
      dispatch(logout());

      navigate(isAdmin ? '/admin' : '/login');
    } catch (_) {
      warningToast(common('login.unableToLogoutContent'), common('login.unableToLogoutTitle'));
      setLogoutLoading(false);
    }
  };

  const HeaderCommonButton = isAdvisor ? BaseButtonOutline : BaseButtonLink;

  const navigationButton = ['/login', '/admin'].includes(location.pathname) ? (
    <HeaderCommonButton onClick={() => navigateToRoute('/register')} data-testid="header-register-button">
      {common('header.register')}
    </HeaderCommonButton>
  ) : (
    <HeaderCommonButton onClick={() => navigateToRoute('/login')} data-testid="header-login-button">
      {common('header.login')}
    </HeaderCommonButton>
  );

  return (
    <>
      <div
        className={classnames('app-header-default', {
          'app-header-default--admin': isAdmin && !hideControls,
        })}
      >
        {isAdmin && !hideControls && adminHeader}
        <AppHeader>
          <div className="row">
            <div className="col-6">{controls}</div>
            {!hideControls && (
              <div className="col-6 app-header__logout">
                {isAdvisor && <LanguageSwitcher />}
                {loggedIn ? (
                  <BaseButtonLink
                    iconLeft
                    icon="arrow-right"
                    onClick={handleLogout}
                    data-testid="header-logout-button"
                    loading={logoutLoading}
                  >
                    {common('header.logout')}
                  </BaseButtonLink>
                ) : (
                  navigationButton
                )}
              </div>
            )}
          </div>
        </AppHeader>
      </div>
      <div className="app-header__children">{children}</div>
    </>
  );
};

export default AppHeaderDefault;
